<h3 class="mb-3">Registration Complete</h3>
<p>Your registration has been successfully submitted and is now pending approval.</p>
<p>You will receive an email notification once your account has been reviewed and approved.</p>
